import { createContext, useContext, useEffect, useState } from "react";
import { fetchSettingsSupabase } from "../lib/supabase";

const SettingsContext = createContext(null);

const DEFAULTS = {
  company_name: "SUV Engineers",
  tagline: "",
  phone: "",
  email: "",
  website: "",
  address: "",
  instagram: "",
  facebook: "",
  linkedin: "",
  about: "",
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);

  useEffect(() => {
    fetchSettingsSupabase()
      .then((data) => setSettings({ ...DEFAULTS, ...data }))
      .catch(() => {});
  }, []);

  return (
    <SettingsContext.Provider value={settings}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext) || DEFAULTS;
}
